import api from '../api';
import { CreateColaboradorDto, ColaboradorResponse, ApiError } from './types';

export class ColaboradorService {
  /**
   * Cria um novo colaborador na landing page
   * @param colaboradorData - Dados do colaborador
   * @returns Promise com resposta do colaborador criado
   */
  static async createColaborador(colaboradorData: CreateColaboradorDto): Promise<ColaboradorResponse> {
    try {
      const response = await api.post<ColaboradorResponse>('colaboradores', colaboradorData);
      return response.data;
    } catch (error: any) {
      throw this.handleApiError(error);
    }
  }

  /**
   * Cria múltiplos colaboradores na landing page
   * @param colaboradoresData - Array de dados dos colaboradores
   * @returns Promise com resposta dos colaboradores criados
   */
  static async createColaboradoresBulk(colaboradoresData: CreateColaboradorDto[]): Promise<ColaboradorResponse[]> {
    try {
      const response = await api.post<ColaboradorResponse[]>('colaboradores/bulk', colaboradoresData);
      return response.data;
    } catch (error: any) {
      throw this.handleApiError(error);
    }
  }

  /**
   * Atualiza um colaborador existente
   * Nota: O backend faz upsert por CPF, então este método usa o mesmo endpoint POST
   * @param colaboradorId - ID do colaborador (não usado, mas mantido para compatibilidade)
   * @param colaboradorData - Dados do colaborador para atualizar
   * @returns Promise com resposta do colaborador atualizado
   */
  static async updateColaborador(
    colaboradorId: number,
    colaboradorData: Partial<CreateColaboradorDto>
  ): Promise<ColaboradorResponse> {
    try {
      // O backend faz upsert por CPF, então usamos o mesmo endpoint POST
      // O colaboradorData deve incluir empresa_id e cpf para o upsert funcionar
      const response = await api.post<ColaboradorResponse>('colaboradores', colaboradorData);
      return response.data;
    } catch (error: any) {
      throw this.handleApiError(error);
    }
  }

  /**
   * Trata erros da API
   */
  private static handleApiError(error: any): ApiError {
    if (error.response?.data) {
      return {
        message: error.response.data.message || 'Erro na requisição',
        statusCode: error.response.status,
        error: error.response.data.error,
      };
    }

    return {
      message: 'Erro de conexão com o servidor',
      statusCode: 500,
      error: 'Network Error',
    };
  }
}
